import { CxEvent } from '@spartacus/core';

export class Ga4GgListingProductSelectEvent extends CxEvent {
  event?: string;
  visitor_type?: string;
  ecommerce?: {
    item_list_name?: string;
    currency?: string;
    items?: {
      item_id?: string;
      item_name?: string;
      price?: number;
      item_list_name?: string;
      quantity?: number;
    }[];
  } | null;
}
